import * as React from 'react'
import classNames from 'classnames'
import { addSeparators } from 'utils'
import { TooltipWrapper } from 'uiComponents/tooltip.new/tooltipWrapper'
import { ProductsCell, ProductsRow } from './productsTable'
import { ProductCell } from './productCell'
import { OnSaleCell } from './onSaleCell'
import { TakesUpCapacityCell } from './takesUpCapacityCell'
import { UsesStepper } from './usesStepper'
import { ProductRowMenu } from './productRowMenu'
import { ProductRowModel } from '../model/rowModel'
import { useTranslation } from 'translations'

interface ProductRowProps {
    row: ProductRowModel
    onToggle: () => void
    onAmountChange: (next: number) => void
    numericId: number | undefined
    numericIdLoading: boolean
}

function UsesCell({ row, onAmountChange }: Pick<ProductRowProps, 'row' | 'onAmountChange'>) {
    const { t } = useTranslation()
    if (row.isBundle) {
        return <span className="capacity-muted">—</span>
    }
    if (row.perCategoryOnly) {
        return (
            <TooltipWrapper
                text={t('capacity.products.stepper.perCategory')}
                arrowPosition="right"
                className="capacity-tip"
                revealOnFocus
            >
                <span className="capacity-muted" tabIndex={0}>
                    —
                </span>
            </TooltipWrapper>
        )
    }
    if (row.amount === null) {
        return <span className="capacity-muted">—</span>
    }
    if (row.isOptionItem || row.status === 'removing') {
        return <span className="capacity-uses-value">{addSeparators(row.amount)}</span>
    }
    return (
        <UsesStepper
            productName={row.member.name}
            value={row.amount}
            changed={row.status === 'changed' || (row.status === 'new' && row.amount !== 1)}
            onChange={onAmountChange}
        />
    )
}

export function ProductRow({ row, onToggle, onAmountChange, numericId, numericIdLoading }: ProductRowProps) {
    return (
        <ProductsRow className={classNames({ 'pending-removal': row.status === 'removing' })}>
            <ProductsCell className="capacity-table-name-cell">
                <ProductCell row={row} />
            </ProductsCell>
            <ProductsCell>
                <OnSaleCell factors={row.onSale} />
            </ProductsCell>
            <ProductsCell>
                <TakesUpCapacityCell takesUp={row.takesUp} isBundle={row.isBundle} />
            </ProductsCell>
            <ProductsCell align="right" className="capacity-table-uses-cell">
                <UsesCell row={row} onAmountChange={onAmountChange} />
            </ProductsCell>
            <ProductsCell align="right">
                <ProductRowMenu
                    productName={row.member.name}
                    status={row.status}
                    onToggle={row.isOptionItem ? undefined : onToggle}
                    viewLink={row.viewLink}
                    isOptionItem={row.isOptionItem}
                    timeSlotsLink={row.timeSlotsLink}
                    numericId={numericId}
                    numericIdLoading={numericIdLoading}
                />
            </ProductsCell>
        </ProductsRow>
    )
}
